export default __webpack_public_path__ + "static/media/ndis-2.d9f1b1e3.png";